<template>
  <div class="catalogue">
    <!-- <div class="retrieval-colse" @click="berforClose"><i class="el-icon-close"></i> </div> -->
    <div class="retrieval-header-box">
      <el-collapse @change="collapseChange" accordion v-model="bookId">
        <el-collapse-item :key="index" :name="item.bookId" v-for="(item, index) in slaveData">
          <template slot="title">
            <i class="callapse-i"></i>{{ item.bookName }}
          </template>
          <!-- <div v-for="(items, index1) in item.catalogues" :key="index1" :title="item.bookName+' '+items.volume+' '+items. chapter" :class="page_active == item.bookId+':'+items.page?'is-active':''" @click="collectHader(item,items)"> -->
          <div :class="page_active == item.bookId+':'+ (items.page-1)?'is-active':''" :key="index1" :title="item.bookName" @click="collectHader(item,items)" v-for="(items, index1) in item.catalogues">
            {{ item.bookName }} {{ items.page }}
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'PortalCatalogue',
    props: {
      slaveData: {
        type: Array,
        default: () => []
      },
      slavePage:{
        type:Object,
        default:()=>{}
      }
    },
    data() {
      return {
        bookId: '',
        // 当前选中page
        page_active: '',
      };
    },
    created() {
    },
    mounted() {
      // this.bookId = this.slavePage.transId
      // this.page_active =this.slavePage.judge == 1 || this.slavePage.judge == 3 ? this.slavePage.transId + ":" + this.slavePage.transPage : this.slavePage.baseId + ":" + this.slavePage.basePage
    },

    methods: {
      berforClose() {
        this.$parent.handClose()
      },

      handCatalogues(item) {
        if (item.bookId == this.showcatalog[0]) {
          this.showcatalog.pop()
        } else {
          this.showcatalog.splice(0, 1, item.bookId)
        }
      },
      collectHader(item, items) {
        // this.bookId = item.bookId
        // this.page_active = item.bookId + ':' + (items.page-1)
        // this.$router.push({
        //     path:'/exhibition',
        //     query:{
        //         bookId:item.bookId,
        //         page:items.page
        //     }
        // })
        // this.$Bus.$emit('cataPage',items.page)
        this.$parent.changePage(items.page-1, true, false)
      },
      collapseChange(item) {
        // if (item == this.$route.query.bookId) return
        // if (!item) return
        // this.page_active = item + ':' + 1
        // this.$router.push({
        //   path: '/exhibition',
        //   query: {
        //     bookId: item,
        //     page: 1
        //   }
        // })
      }
    },

    computed:{
      judge(){
        return this.slavePage
      }
    },
    watch: {
      judge: {
        handler: function (news, old) {
          console.log(news);
          if(news.judge == 1 || news.judge == 3){
            this.bookId = this.slavePage.transId
            this.page_active = this.slavePage.transId + ":" + this.slavePage.transPage
            console.log( this.page_active);
          }else{
            this.bookId = this.slavePage.baseId
            this.page_active = this.slavePage.baseId + ":" + this.slavePage.basePage
            console.log( this.page_active);
          }
        },
        deep: true,
        immediate: true
      }
    },
  };
</script>

<style lang="less" scoped>
  .exhibition-left {
    &.close {
      .catalogue {
        display: none !important;
      }
    }

    &.open {
      .catalogue {
        display: block;
      }
    }
  }

  .catalogue {
    width: 16.667rem;
    height: 100%;
    position: relative;
    margin: 0;
    .retrieval-colse {
      position: absolute;
      top: 0.885rem;
      right: 1.042rem;
      width: 1rem;
      height: 1rem;
      box-sizing: border-box;
      border: 1px solid #4b2200;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      i {
        font-size: 0.88rem;
        line-height: unset;
      }
    }

    .retrieval-header-box {
      padding: 1rem 0rem 0rem 1.5rem;
      font-size: 1rem;

      /deep/ .el-collapse {
        border-top: none;

        .el-collapse-item {
          .el-collapse-item__header {
            display: flex;
            align-items: center;
            font-size: .9rem;
            line-height: normal;
            height: unset;
            padding: .5rem 0;

            .callapse-i {
              display: block;
              font-size: .9rem;
              color: #606266;
              transition: color .15s linear;
              font-family: element-icons !important;
              font-style: normal;
              font-weight: 400;
              font-variant: normal;
              text-transform: none;
              display: inline-block;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
              margin-right: .5rem;

              &::before {
                content: '\e6d9';
              }
            }

            &.is-active {
              .callapse-i {
                &::before {
                  content: '\e6d8';
                }
              }
            }

          }

          .el-collapse-item__content {
            font-size: .7rem;
            padding-bottom: 0;
            cursor: pointer;
            overflow: auto;
            max-height: 47.23958333333333rem;
            div {
              padding: 0.5rem 0.5rem;
              margin-right: 0.5rem;

              &.is-active {
                background-color: #f3edcb;
                border-top-left-radius: 6px;
                border-bottom-left-radius: 6px;
              }

              // &:last-child{
              //     padding-bottom:unset;
              // }
            }

          }

          .el-collapse-item__arrow {
            display: none;
          }
        }
      }
    }
  }
</style>
